import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e3yxzqwr92: FaireBrandEntity = {
  token: "b_e3yxzqwr92",
  type: "brand",
  name: "Forte",
  avatarUrl:
    "https://cdn.faire.com/fastly/9ed22052da8c93b518b77ad0ad5bb61e95d3afc007fd8600a877ce7668f8e904.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/028aed731ec9c9b4522e4e00ed2e25b5d14759ca8105bfc42b74fe9909283c2d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9ed22052da8c93b518b77ad0ad5bb61e95d3afc007fd8600a877ce7668f8e904.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/028aed731ec9c9b4522e4e00ed2e25b5d14759ca8105bfc42b74fe9909283c2d.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 49,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Forte â where modern femininity meets refined elegance.\n\nForte is a contemporary women's brand that embodies elevated style, refined elegance, and effortless sophistication.\n\nA women's clothing brand designed for those who appreciate elevated essentials and timeless sophistication. With a focus on graceful details and flattering silhouettes, our pieces are made to move effortlessly whether she's dressing for a special occasion or her every day. Each collection is crafted to celebrate confidence and style.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:47.429Z",
    importedBy: "entity-db-cli",
  },
};
